<div class="form-group" *ngIf="bStyle">
    <nirby-slider
        [value]="bStyle.borderRadius"
        [min]="0"
        [max]="1"
        [step]="0.01"
        (valueChange)="updateCornerRadius($event)"
    ></nirby-slider>
</div>
